import React from 'react';
import {Stack, ToggleButton, ToggleButtonGroup, Typography} from '@mui/material';
import {COVERAGE_SOURCE} from '../coverageSourceTheme';

/**
 * Standalone source lens for the Coverage tab list — not nested in the
 * Coverage snapshot card.
 */
export default function CoverageSourceLens({lens = 'both', onLensChange}) {
    return (
        <Stack
            data-testid="coverage-source-lens"
            direction={{xs: 'column', sm: 'row'}}
            spacing={1.25}
            alignItems={{xs: 'stretch', sm: 'center'}}
            justifyContent="space-between"
            sx={{
                py: 1.25,
                px: 0.25,
                borderBottom: '1px solid',
                borderColor: 'divider',
            }}
        >
            <Typography variant="subtitle2" fontWeight={700} color="text.primary">
                View coverage from
            </Typography>
            <ToggleButtonGroup
                exclusive
                size="small"
                value={lens}
                onChange={(_event, next) => {
                    if (next) onLensChange?.(next);
                }}
                sx={{
                    alignSelf: {xs: 'stretch', sm: 'flex-end'},
                    '& .MuiToggleButton-root': {
                        px: 1.75,
                        textTransform: 'none',
                        fontWeight: 600,
                    },
                }}
            >
                <ToggleButton value="both" aria-label="Show both coverage sources">
                    Both
                </ToggleButton>
                <ToggleButton
                    value="data"
                    aria-label="Show Data coverage"
                    sx={{
                        '&.Mui-selected': {
                            color: COVERAGE_SOURCE.DATA.color,
                            bgcolor: 'grey.100',
                            '&:hover': {bgcolor: 'grey.200'},
                        },
                    }}
                >
                    Data
                </ToggleButton>
                <ToggleButton
                    value="analytics"
                    aria-label="Show Analytics coverage"
                    sx={{
                        '&.Mui-selected': {
                            color: COVERAGE_SOURCE.ANALYTICS.color,
                            bgcolor: 'grey.100',
                            '&:hover': {bgcolor: 'grey.200'},
                        },
                    }}
                >
                    Analytics
                </ToggleButton>
            </ToggleButtonGroup>
        </Stack>
    );
}
